let disableTrackingIdTypingDirective = (SetupService, User) => {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attrs, controller) => {
            return SetupService.get(User.getUser().branchId)
                .then((data) => {
                    if (!data.disableTrackingIdTyping) return;
                    let lastKeypressTime = 0;
                    let inputBuffer = [];
                    element.on('keypress', (event) => {
                        const currentTime = Date.now();
                        const char = String.fromCharCode(event.which);
                        
                        if (currentTime - lastKeypressTime < 1500) {
                            inputBuffer.push(char);
                            if (inputBuffer.length >= 6) {
                                let value = inputBuffer.join('');
                                controller.$setViewValue(value);
                                controller.$render();
                            }
                        } else {
                            inputBuffer = [char];
                        }

                        lastKeypressTime = currentTime;

                        if (inputBuffer.length === 1) {
                            setTimeout(() => {
                                if (inputBuffer.length < 6) {
                                    alert("Manual typing is not allowed!");
                                    controller.$setViewValue(' ');
                                    controller.$render();
                                    inputBuffer = [];
                                }
                            }, 1500);
                        }
                    });
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }
}

disableTrackingIdTypingDirective.$inject = ['SetupService', 'User'];

export default disableTrackingIdTypingDirective;


// WEBPACK FOOTER //
// ./client/app/common/disable-tracking-id-typing/disable-tracking-id-typing.directive.js